import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import MenuViewModelType from '@/ViewModels/Controls/MenuViewModel';

export default class Menu extends Control {

    private jQueryControl: JQuery;

    /**
     * @override
     */
    public widget: KnockoutObservable<kendo.ui.Menu>;

    public constructor(private viewModel: MenuViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<ul>');

        this.applyBindings(this.jQueryControl, {
            locator: this.viewModel.locator,

            kendoMenu: {
                animation: this.viewModel.animation,

                hoverDelay: 150,
                
                direction: this.viewModel.direction,
                orientation: this.viewModel.orientation,
                
                openOnClick: true,

                widget: this.widget
            }
        });

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: kendo.ui.Menu): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'menu',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            menuItems: {
                parent: this,

                items: this.viewModel.items,

                widget: this.widget
            },

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    if (this.viewModel.isApplicationMenu() === true) {
                        styles.push('applicationmenu');
                    }

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    return states;
                }
            })
        });
    }
}

ComponentManager.setControl('Menu', Menu, 'RADPresentation.HTMLClient.DefaultViewExtensions');